import React from 'react';
import { NavLink } from 'react-router-dom';
import { X } from 'react-feather';
import MaximusPrice from '../MaximusPrice';
import AccountButton from '../AccountButton';
import { colorWhite } from '../../colors';
import './MobileMenu.scss';

interface MobileMenuProps {
  onDismiss: () => void;
  visible?: boolean;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ onDismiss, visible }) => {
  if (visible) {
    return (
      <div className="mobile-menu-wrapper">
        <div className="mobile-menu-backdrop" onClick={onDismiss} />
        <div className="mobile-menu">
          <div className="header no-select">
            <div className="empty" />
            <AccountButton />
            <div className="close clickable" onClick={onDismiss}>
              <X color={colorWhite} size={24} />
            </div>
          </div>

          <NavLink
            className="item clickable"
            activeClassName="active"
            to="/pool"
            onClick={onDismiss}>
            POOL
          </NavLink>
          <NavLink
            className="item clickable"
            activeClassName="active"
            to="/zap"
            onClick={onDismiss}>
            ZAP
          </NavLink>
          <a
            className="item clickable"
            target="_blank"
            href="https://exchange.lydia.finance/#/swap?outputCurrency=0x885d748C00A279B67A7749EC6b03301700dd0455">
            BUY MAXI
          </a>
          {/*<a className='item clickable' href='https://vote.maximus.finance' target='_blank' rel='noopener noreferrer'>Vote</a>*/}
          {/*<a className='item clickable' href='https://docs.maximus.finance' target='_blank' rel='noopener noreferrer'>Wiki</a>*/}

          <div className="footer no-select clickable">
            <MaximusPrice />
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default MobileMenu;
